module.exports = __webpack_public_path__ + "static/real-estate-79b941d8626b6b2c5d0305d264e05426.svg";